import React, {Component} from 'react';
import {inject, observer} from "mobx-react";
import {Button, Input, TabPane} from "reactstrap";
import {choisirTheme, themeActif} from "../../../../util/theme";

const THEMES = [
    {id: "classique", nom: "Classique", description: "Clair et sobre", couleurs: ["#ffffff", "#20a8d8", "#2f353a"]},
    {id: "jeu-video", nom: "Jeu vidéo", description: "Néons d'arcade", couleurs: ["#0d0b1e", "#2de2e6", "#ff3caa", "#ffd23f"]},
    {id: "final-fantasy", nom: "Final Fantasy", description: "Fenêtres de RPG", couleurs: ["#050a3d", "#2f58d8", "#e3e5f2", "#ffe27a"]},
];


const SecondAsidePage = inject("rootStore")(observer(class SecondAsidePage extends Component {

        constructor(props) {
            super(props);
            this.state = {
                theme: themeActif()
            }
        }

        get injected() {
            return this.props
        }

        choisirTheme(theme) {
            choisirTheme(theme)
            this.setState({theme: theme})
        }

        async onUpdateLogo(e) {
            e.preventDefault()
            await this.injected.rootStore.authStore.updateSidebar(this.state)
        }


        async onAddSong(e) {
            e.preventDefault()
            let data = {
                file: this.state.file2,
                type: "audio"
            }
            await this.injected.rootStore.imageStore.saveOne(data)
        }


        render() {
            return (

                <TabPane tabId="2" className="p-3">

                    <section className="menu-reglages-section">
                        <h6 className="menu-reglages-titre"><i className="fa fa-gamepad" aria-hidden="true"></i> Thème</h6>
                        <div className="menu-reglages-themes">
                            {THEMES.map(theme => (
                                <button
                                    key={theme.nom}
                                    type="button"
                                    className={"menu-reglages-theme" + (this.state.theme === theme.id ? " actif" : "")}
                                    aria-pressed={this.state.theme === theme.id}
                                    onClick={() => this.choisirTheme(theme.id)}>
                                    <span className="menu-reglages-apercu">
                                        {theme.couleurs.map(couleur => (
                                            <span key={couleur} style={{background: couleur}}/>
                                        ))}
                                    </span>
                                    <strong>{theme.nom}</strong>
                                    <small>{theme.description}</small>
                                </button>
                            ))}
                        </div>
                        <small className="text-muted">Mémorisé sur ce poste.</small>
                    </section>

                    <section className="menu-reglages-section">
                        <h6 className="menu-reglages-titre"><i className="fa fa-picture-o" aria-hidden="true"></i> Fond du menu latéral</h6>
                        <small className="text-muted d-block mb-2">Fichier actuel : {this.injected.rootStore.authStore.sidebar}</small>
                        <Input type="file"
                               name="file"
                               id="fondSidebar"
                               bsSize="sm"
                               className="mb-2"
                               onChange={e => this.setState({file: e.target.files[0]})}
                        />
                        <Button size="sm" block onClick={e => this.onUpdateLogo(e)} color="success">Modifier</Button>
                    </section>

                    <section className="menu-reglages-section">
                        <h6 className="menu-reglages-titre"><i className="fa fa-music" aria-hidden="true"></i> Musiques des notifications</h6>
                        <ul className="menu-reglages-musiques">
                            {this.injected.rootStore.songStore.datas.map((song) => {
                                return (
                                    <li key={song.id}>
                                        <span className="menu-reglages-categorie">{song.category.toLowerCase()}</span>
                                        <span>{song.asset?.nom}</span>
                                    </li>
                                )
                            })}
                        </ul>
                        <Input type="file"
                               name="file"
                               id="ajoutMusique"
                               bsSize="sm"
                               className="mb-2"
                               onChange={e => this.setState({file2: e.target.files[0]})}
                        />
                        <Button size="sm" block onClick={e => this.onAddSong(e)} color="success">Ajouter une musique</Button>
                    </section>

                </TabPane>


            )


        }
    }
));

export default SecondAsidePage;
